/*
	支払方法管理画面
	クレジットカード新規作成　入力フォーム
*/

import React, { memo } from 'react';
import classes from './new-card-input-form.module.scss';

type Props = {
	isSaveCard: boolean;
	isGakkenUser?: boolean;
	handleChangeCheckValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
	selectedPeriodicPaymentFlg: boolean;
};
export const NewCardInputForm = memo((props: Props) => {
	const { isSaveCard, isGakkenUser = true, handleChangeCheckValue, selectedPeriodicPaymentFlg } = props;
	return (
		<>
			<div className={classes.paymentCreditCardInput}>
				<div className="form-box">
					<div className="form-head">
						<label htmlFor="">カード番号 （Card Number）</label>
						<span className="required">必須</span>
					</div>
					<div className="form-input width50">
						<div id="card-number" className={classes.cardField} />
					</div>
				</div>
				<div className="form-box">
					<div className="form-head">
						<label htmlFor="">有効期限 （Expiration Date）</label>
						<span className="required">必須</span>
					</div>
					<div className={classes.paymentCreditExpirationDateRow + ` form-input width50`}>
						<div className={classes.paymentCreditExpirationDateSelectBox}>
							<div id="expiration-month" className={classes.cardField} />
						</div>
						<span className={classes.paymentCreditExpirationDateSlash}>/</span>
						<div className={classes.paymentCreditExpirationDateSelectBox}>
							<div id="expiration-year" className={classes.cardField} />
						</div>
					</div>
				</div>
				<div className="form-box">
					<div className="form-head">
						<label htmlFor="">セキュリティコード （Security Codes）</label>
						<span className="required">必須</span>
					</div>
					<div className="form-input width50">
						<div id="cvv" className={classes.cardField} />
					</div>
				</div>
				{/* 注文者区分がGakkenIDの場合のみ表示する */}
				{isGakkenUser && (
					<div className="form-box">
						<div className="form-input">
							<div className="check-box">
								<ul>
									<li>
										<label
											className={`check-label ${
												selectedPeriodicPaymentFlg ? 'is-active' : isSaveCard ? 'is-active' : ''
											}`}
											htmlFor="saveCard"
										>
											<input
												type="checkbox"
												id="saveCard"
												disabled={selectedPeriodicPaymentFlg}
												checked={!selectedPeriodicPaymentFlg ? isSaveCard : true}
												onChange={!selectedPeriodicPaymentFlg && handleChangeCheckValue}
											/>
											カード情報を保存する
										</label>
									</li>
								</ul>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
});
